const levelNames = {
  5: 'Very High',
  4: 'High',
  3: 'Medium',
  2: 'Low',
  1: 'Very Low',
}

export { levelNames }
